import { config } from '@abyss/web/tools/config';

import { Constants } from '../../common/Constants';
import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import {
  PriorityItem,
  updatePopoverPriority,
} from '../../utils/priorityPopover';
import { useCustomQuery } from '../useCustomQuery';
import { useFeatureFlag } from '../useFeatureFlag';
import { useLagoon } from '../useLagoon';
import GET_RECOMMENDATION_PREFERENCE from './GetRecommendationPreferencesStatus.graphql';

export const useGetRecommendationPreferencesStatus = (options) => {
  const priorityList = useLagoon(
    Constants.LAGOON_TABLE.POPOVER_PRIORITIES
  )() as PriorityItem[];
  const [enablePopoverPriorityFlow] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_POPOVER_PRIORITY_FLOW,
  ]);
  const [queryResults, queryAction] = useCustomQuery(
    GET_RECOMMENDATION_PREFERENCE,
    {
      ...options,
      url: config('GRAPHQL_API_URL'),
      requestPolicy: 'no-cache',
      accessor: 'recommendationPreferencesStatus',
      onCompleted: (result) => {
        if (enablePopoverPriorityFlow) {
          updatePopoverPriority(result, priorityList);
        }
        if (options?.handleSuccess) {
          options?.handleSuccess(result);
        }
      },
      onError: (error) => {
        if (options?.handleError) {
          options?.handleError();
        }
        throw error;
      },
    }
  );

  return [queryResults, queryAction];
};
